/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Paper, Stack } from "@mui/material";
import { FC } from "react";
import styled from "@emotion/styled";
import { useTaskRegisterDataContext } from "context/TaskRegisterDataProvider";
import { JobItem } from "components/TaskRegisterMultipleCharge/hooks/GetMultipleChargeTasksHook";
import { DisplayItem } from "components/Common/DisplayItem";
import { formatDate } from "utils/DateTime";
import { Const } from "const";
import { useTranslation } from "react-i18next";

interface JobCardProps {
  job: JobItem;
}
export const JobCard: FC<JobCardProps> = ({ job }) => {
  const { t } = useTranslation();
  const { pointNodes, materials } = useTaskRegisterDataContext();
  const materialName =
    materials?.find((m) => m.type === job.materialId)?.name ?? "--";
  const loadingNodeLabel =
    pointNodes.find((n) => n.nodeId === job.loadingNodeId)?.label ?? "--";
  const unloadingNodeLabel =
    pointNodes.find((n) => n.nodeId === job.unloadingNodeId)?.label ?? "--";
  const requestedEndDatetime =
    job.planningEndDatetime !== undefined
      ? formatDate(job.planningEndDatetime, Const.dateTimeFormat)
      : "--";

  return (
    <JobCardPaper elevation={2}>
      <Stack spacing={1}>
        <DisplayItem title={t("AWVUI-MSG221")} value={`${job.id}`} />
        <DisplayItem
          title={t("AWVUI-MSG204")}
          value={`${materialName}/ ${t("AWVUI-MSG205")}: ${
            job.materialQuantity
          }`}
        />
        <DisplayItem title={t("AWVUI-MSG206")} value={loadingNodeLabel} />
        <DisplayItem title={t("AWVUI-MSG208")} value={unloadingNodeLabel} />
        <DisplayItem title={t("AWVUI-MSG216")} value={requestedEndDatetime} />
      </Stack>
    </JobCardPaper>
  );
};

const JobCardPaper = styled(Paper)(({ theme }) => ({
  padding: "5px",
}));
